// extracted by mini-css-extract-plugin
module.exports = {"TitleWithLogo":"Style_TitleWithLogo__3RSr5","TitleWithLogo_title":"Style_TitleWithLogo_title__LjDwW"};